export default "__VITE_ASSET__CnnV58bb__"